/**
 * Square, label-less control for row actions, toolbars, dismissals.
 * Spec: assets/handoffs/design_system_export/specs/IconButton.json
 *
 * @param {'sm'|'md'=md} size
 * @param {'ghost'|'outline'=ghost} variant
 * @param {ReactNode} icon - required
 * @param {string} label - required, becomes aria-label
 * @param {boolean=false} disabled
 */
import React, { forwardRef } from "react";
import classNames from "classnames";
import styles from "./IconButton.module.scss";

const IconButton = forwardRef(
  (
    { size = "md", variant = "ghost", icon, label, disabled = false, className, ...rest },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type="button"
        disabled={disabled}
        aria-label={label}
        className={classNames(
          styles.root,
          styles[`root--${size}`],
          styles[`root--${variant}`],
          className
        )}
        {...rest}
      >
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      </button>
    );
  }
);

IconButton.displayName = "IconButton";

export default IconButton;
